export default {
      id: "icon--wear-non-wooly-gloves-usage",
      viewBox: "0 0 31.1 30",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--wear-non-wooly-gloves-usage",
      toString: function () {
        return this.url;
      }
    }